import { css, unsafeCSS } from 'lit';
import {
  fsColorInteractionBlue30,
  fsFontWeightSemibold,
  fsFontWeightExtraLight,
  fsColorBackgroundLight,
  fsColorCoreBlue60,
} from '@cof/fs-tokens';

export const style = css`
  .bold-text {
    font-weight: ${unsafeCSS(fsFontWeightSemibold)};
  }

  .blue-text {
    color: ${unsafeCSS(fsColorInteractionBlue30)};
  }

  .blue-fill {
    filter: brightness(0) saturate(100%) invert(59%) sepia(85%) saturate(1025%)
      hue-rotate(170deg) brightness(99%) contrast(101%);
  }

  @media (height <= 700px) {
    /* Account for short device height, push car graphic off screen instead of anchoring it to the bottom */
    .bottom-graphic {
      align-items: center;
      bottom: 0;
      display: flex;
      justify-content: center;
      overflow: hidden;
      position: relative;
      width: 100vw;
    }

    .full-page {
      height: auto;
    }
  }

  @media (height >= 701px) {
    .bottom-graphic {
      align-items: center;
      bottom: 0;
      display: flex;
      justify-content: center;
      overflow: hidden;
      position: absolute;
      width: 100vw;
    }

    .full-page {
      height: calc(100vh - 8.25rem);
    }
  }

  .car-footer {
    width: 100%;
  }

  .semicircle {
    background: ${unsafeCSS(fsColorBackgroundLight)};
    border-radius: 50%;
    bottom: -15%;
    height: 67%;
    overflow: hidden;
    position: absolute;
    width: 125vw;
    z-index: 1;
  }

  .body-content {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
  }

  .car-logo {
    scale: 1;
    z-index: 2;
  }

  .check-list-box {
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  .check-list-items {
    align-items: center;
    align-self: stretch;
    display: flex;
    font-weight: ${unsafeCSS(fsFontWeightExtraLight)};
    gap: 0.5rem;
  }

  .check-list-title {
    padding-bottom: 1rem;
  }

  .credit-pull-modal-body-text {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .cta-button-container {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .fast-lane-title {
    white-space: nowrap;
  }

  .full-page {
    align-items: center;
    align-self: stretch;
    background: ${unsafeCSS(fsColorCoreBlue60)};
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .text-content {
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    padding-bottom: 1rem;
    width: 325px;
    z-index: 3;
  }

  .two-line-text-icon {
    padding-bottom: 1.5rem;
  }

  .get-started-button {
    width: 100%;
  }

  .coapp-button {
    width: 100%;
  }

  .modal-btn {
    align-self: flex-end;
  }

  @media (width <= 48em) {
    .car-logo {
      scale: 0.7;
    }
  }

  svg {
    height: auto;
    width: 100%;

    @media (width <= 48rem) {
      max-width: 24.375rem;
    }
  }
`;
